import { Bar, BarChart, CartesianGrid, XAxis } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from 'app-template-lib/components/shadcn';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from 'app-template-lib/components/shadcn';
// import { ChartConfig } from 'node_modules/app-template-lib/dist/lib/shadcn/components/ui/chart';
import { DashBoardData } from '../../../top/toppage.presenter.hooks';
import { ToWarekiFormatter } from '@/features/openProjects/utils/toWarekiFormatter';

// type yosanDatas = {
//     jigyoYear: string;
//     yosan: number;
// };
export interface DashboardBarchartProps {
    dashBoardDatas: DashBoardData;
    lgconfig: { id: string; lgcode: string; created_year: number } | undefined;
    jigyoYear: string | undefined;
}

export function BarChartWidget({ dashBoardDatas, lgconfig, jigyoYear }: DashboardBarchartProps) {
    const createdYear = lgconfig?.created_year;
    const chartConfig = {
        yosan: {
            label: createdYear === Number(jigyoYear) ? '一般会計　当初予算額' : ' 一般会計　決算額',
            color: 'hsl(var(--chart-1))',
        },
    };
    // satisfies ChartConfig;

    // 予算額を「万円」「億円」表示にフォーマット
    const formatYosan = (value: number) => {
        const oku = Math.floor(value / 100000000); // 億の部分
        const man = Math.floor((value % 100000000) / 10000); // 万の部分
        const yen = value % 10000; // 余り（万円未満）

        let result = '';
        if (oku > 0) result += oku.toLocaleString() + '億';
        if (man > 0) result += man.toLocaleString() + '万';
        if (yen > 0) result += yen.toLocaleString() + '円';

        return result;
    };

    // 決算表示時は予算データを非表示

    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    {createdYear === Number(jigyoYear) ? '一般会計　当初予算額推移' : ' 一般会計　歳出決算額推移'}
                </CardTitle>

                {/* <CardDescription>ss</CardDescription> */}
            </CardHeader>
            <CardContent>
                <ChartContainer config={chartConfig}>
                    <BarChart accessibilityLayer data={dashBoardDatas?.yosanDatas}>
                        <CartesianGrid vertical={false} />
                        <XAxis
                            dataKey="jigyo_year"
                            tickLine={false}
                            tickMargin={10}
                            axisLine={false}
                            tickFormatter={(value) => ToWarekiFormatter(value)}
                        />
                        {/* <ChartTooltip content={<ChartTooltipContent hideLabel formatter={(value: number) => formatYosan(value)} />} /> */}
                        <Bar
                            dataKey={createdYear === Number(jigyoYear) ? 'saishutsuYosan' : 'saishutsuKessan'}
                            stackId="a"
                            fill="hsl(var(--chart-1))"
                            radius={[4, 4, 0, 0]}
                            label={{
                                position: 'top',
                                formatter: (value: number) => formatYosan(value),
                            }}
                        />
                    </BarChart>
                </ChartContainer>
            </CardContent>
        </Card>
    );
}
